export var PASTE_PAPER_COPY = "Paste paper";
export var CHECK_MY_PAPER_BUTTON_COPY = "Check my paper";
export var IMPORT_PAPER_COPY = "or import your paper";
export var COMPUTER_BUTTON_COPY = "Computer";
export var COMPUTER_LABEL_COPY = "Upload from computer";
export var GOOGLE_DRIVE_BUTTON_COPY = "Google Drive";
export var GOOGLE_DRIVE_LABEL_COPY = "Upload from Google Drive";
export var TERMS_CONDITIONS_COPY = "See terms and conditions";
export var HEADER_DEFAULT_COPY = "Turn in your best paper";
export var SUBHEADER_DEFAULT_COPY = "We check your paper against billions of sources using technology similar to Turnitin";
export var LEGAL_COPY = "The papers you upload will be added to our plagiarism database and will be used internally to improve plagiarism results.";
export var ERROR_FILETYPE_COPY = "Sorry we don't support this file type. Please try again.";
export var ERROR_DEFAULT_COPY = "Hmm, that didn't work.  Please try again.";
export var ERROR_MAX_COPY = "We have a file maximum of 80KB.  Please try again.";
export var PROCESSING_PAPER_COPY = "Processing your paper";
export var DEMO_LINK_COPY = "Check out our demo page";
export var DEMO_LINK_TOOLTIP_COPY = "See how it works";